<template>
  <div class="scroll-table">
    <table v-if="localTrainings" class="table table-list-training table-list-training-with-hover">
      <thead>
        <tr>
          <th>{{ $t('src/components/training/traininglist.1647') }}</th>
          <th>{{ $t('src/components/training/traininglist.9129', { '1': getDateToday }) }}</th>
          <th>{{ $t('general.duration') }}</th>
          <th>{{ $t('sessionsInfo.averageHeartRate') }}</th>
          <th>{{ $t('sessionsInfo.averagePace') }}</th>
          <th>{{ $t('src/components/training/traininglist.670') }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <router-link
          tag="tr"
          v-for="training in localTrainings"
          :key="training.id"
          :to="{ name: 'session-view', params: { id: training.id } }"
        >
          <td class="training-status" :class="[`training-status-${getStatusColor(training)}`]">
            {{ getStatusTitle(training) }}
          </td>
          <td>{{ getTrainingFormattedStartDate(training) }}</td>
          <td class="position-relative">
            <training-duration :training="training"></training-duration>
            <span :class="[{ 'table-list-training-6mwt': isTrain6MWT(training) }]"></span>
          </td>
          <td>{{ getAverageHRR(training) }}</td>
          <td>{{ getAverageStepRate(training) }}</td>
          <td>{{ getBorgScale(training) }}</td>
          <td>
            <svg-icon
              v-if="isCanRemove(training) && hasRightsToEdit"
              @click:icon="removeTraining(training.id)"
              class="icon-remove-training"
              :name="'cross-in-circle'"
            ></svg-icon>
          </td>
        </router-link>
      </tbody>
    </table>
  </div>
</template>

<script>
import { trainingItem } from '@/mixins/training-item.js'
import { nowMoment } from '@/mixins/now-moment.js'
import getAverageOfArray from '@/modules/average-of-array.js'
import('@/styles/components/trainings-list.less')

export default {
  name: 'TrainingList',
  components: {
    TrainingDuration: () => import('@/components/Training/TrainingDuration.vue'),
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  mixins: [trainingItem, nowMoment],
  props: {
    trainings: {
      type: Array,
      required: true
    },
    hasRightsToEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    localTrainings: null
  }),
  computed: {
    getDateToday() {
      return this.nowFormat
    }
  },
  watch: {
    trainings() {
      this.localTrainings = this.trainings
    }
  },
  created() {
    this.localTrainings = this.trainings
  },
  methods: {
    removeTraining(trainingId) {
      this.$emit('remove', trainingId)
    },
    getAverageStepRate(training) {
      const stepRate = JSON.parse(training.step_rates)
      if (!stepRate || stepRate.rateValues.length === 0) {
        return '—'
      }
      return `${getAverageOfArray(stepRate.rateValues)} ${this.$t('unit.sm')}`
    },
    getBorgScale(training) {
      if (!training.borg_scale) {
        return '—'
      }
      return training.borg_scale
    },
    showDate(training) {
      let today_date = new Date(new Date().setHours(0, 0, 0, 0))
      let index = this.trainings.findIndex(item => item.id == training.id)

      let date_training = new Date(this.getTrainingStartDate(training))
      let date_prev_training = new Date(this.getTrainingStartDate(this.trainings[index - 1]))

      if (!this.isTodayDate(this.getTrainingFormattedStartDate(training))) {
        if (index == 0) {
          if (today_date < date_training) {
            return true
          }
        } else {
          if (today_date < date_training && today_date > date_prev_training) {
            return true
          }
        }
      }
      return false
    },
    showLastDate(training) {
      let today_date = new Date(new Date().setHours(0, 0, 0, 0))
      let date_last = new Date(this.getTrainingStartDate(this.trainings[this.trainings.length - 1]))

      if (today_date > date_last && this.trainings[this.trainings.length - 1].id == training.id) {
        return true
      } else return false
    },
    getAverageHRR(training) {
      let hr = this.getAverageHR(training)
      if (hr !== '—') return `${hr} ${this.$t('unit.bpm')}`
      else return hr
    }
  }
}
</script>
